<template>
    <div>
		<Breadcrumb class="tablelist-header">
			<BreadcrumbItem >{{$t('erp.channel.warehouse_manage', { defaultValue: '渠道仓库管理' })}}</BreadcrumbItem>
		</Breadcrumb>
		<div style="position:relative">
        <compSearch @on-update="updateList"></compSearch>
		<Table 
		:columns="columns" 
		:data="data"
		:loading="loading"
		size="small" 
		ref="table"  
		@on-sort-change='sortChange' 
		@on-selection-change='handleChecked'
		border 
		stripe></Table>
		<compSpage
		class="text-right margin-top-10 padding-bottom-50"
		v-bind="{total,pageSize:formData.rows,current:formData.page}" 
		@on-update="updateList"></compSpage>
		<Modal
		class="hidefooter"
		v-model='operate.show'
		:mask-closable='false' 
		v-bind="operate">
			<component :is="operate.component" @on-close="operate={}" v-bind="operate" v-if="operate.show"/>
			<!-- <footer slot="footer" v-if="operate.footer"></footer> -->
		</Modal>
		<div v-if="showDel">
			<compDelModal  @on-close='showDel=false' @on-confirm='operateBatch' v-bind="operate"/>
		</div>
		<Spin size="large" fix v-if="loading"></Spin>
		</div>
	</div>
</template>

<script>

import compSearch from './search';
import compDetail from './detail';
import compLog from './log';
import compSpage from '@/components/boss/spage';
import compDelModal from '@/components/boss/delModal';
import { HttpWhAccountList, HttpCancelWhAccount } from '@/service/boss/allot';
import { DropdownMenu, Dropdown, DropdownItem, Icon, Button } from 'view-design';
export default {
	components: {
		compSearch,
		compSpage,
		compDelModal,
		compLog,
		compDetail
	},
	data() {
		return {
			data: [],
			checkedId: [],
			total: 0,
			showDel: false,
			loading: false,
			operate: {
				id: null,
				title: "",
				show: false,
				component: null
			},
			formData: {
				page: 1,
				rows: 10,
				sidx: 'id',
				sord: 'desc',
			},
		};
	},

	methods: {
		download() {
			if (this.checkedId.length == 0) {
				this.$Message.warning(this.$t('global.common.selectdata', { defaultValue: "请选择至少一条数据" }));
				return;
			};
			this.handleWebfs(process.env.VUE_APP_APIURL_BOSS +"/api/v2/StockAccountAddress/export", { accountIds: this.checkedId.join(',')}, 'download')
		},
		handleChecked(selection, row) {
			this.checkedId = selection.map(item => {
				return item.account_id
			});
		},
		handleOperate(id, type) {
			this.operate = {};
			switch (type) {
				case 'add':
					this.$router.push({ name: 'whUpdateAccount', params: { type: 'add' } })
					break;
				case 'edit':
                    const { href } = this.$router.resolve({
                        name: 'whUpdateAccount',
                        params: {
                            type: 'edit'
                        },
                        query: { id } 
                    });
                    window.open(href, "_blank");
					break;
				case 'cancel':
					this.showDel = true;
					this.operate = {
						id,
						title: this.$t('fbb.accountmanage.operate_loss_effect', { defaultValue: '失效操作' }),
						type,
					}; break;
				case 'query':
					this.operate = {
						id,
						title: this.$t('global.common.operation_see', { defaultValue: '查看' }),
						show: true,
						component: "compDetail",
						width: 720,
						footer:false,
					}; break;
				// case 'log':
				// 	this.operate = {
				// 		id,
				// 		title: '查看日志',
				// 		show: true,
				// 		component: "compLog",
				// 		width: 720,
				// 	}; break;
				case 'download': this.download();
					break;
			}
		},

		sortChange({ column, key, order }) {
			this.updateList({ sidx: key, sord: order });
		},
		async operateBatch() {
			const response = await HttpCancelWhAccount({ accountId: this.operate.id }).catch(err => {
				this.errorMessage(err.message);
			});
			if (response) {
				this.$Message.success(response.message);
				this.updateList();
			}
			this.operate = {};
			this.showDel = false;
		},
		async updateList(data) {
			this.loading = true
			this.formData = Object.assign({}, this.formData, data);
			const response = await HttpWhAccountList(this.formData).catch(res => {
				this.loading = false;
				this.$Message.error(res.message);
			});
			if (response) {
				const data = response.data;
				this.loading = false;
				this.data = data.content || [];
				this.total = data.totalElements || 0;
			}
		},
	},
	computed: {
		columns() {
            const that = this;
			return [
				{
					width: 60,
					type: "selection",
				},
				{
					title: this.$t('global.common.actions', { defaultValue: '操作' }),
					width: 100,
					render: (h, { row }) => {
						const id = row.account_id, show = row.status === 1
						return <div>
							<Dropdown placement="bottom-start" trigger="click">
								<Button size="small" type='info'>{this.$t('global.common.actions', { defaultValue: '操作' })}<Icon type="md-arrow-dropdown" /></Button>
                                <DropdownMenu slot="list" class="text-left">
                                    <DropdownItem v-show={show} class='splitline' nativeOnClick={this.handleOperate.bind(this, id, 'query')}>{this.$t('global.common.query', { defaultValue: '查看' })}</DropdownItem>
                                    <DropdownItem v-show={show} class='splitline' nativeOnClick={this.handleOperate.bind(this, id, 'edit')}>{this.$t('global.common.operation_edit', { defaultValue: '编辑' })}</DropdownItem>
									<DropdownItem v-show={show} class='splitline' nativeOnClick={this.handleOperate.bind(this, id, 'cancel')}>{this.$t('global.common.failure', { defaultValue: '失效' })}</DropdownItem>
								</DropdownMenu>
							</Dropdown >
						</div>
					}
				},
				{
					title: this.$t('erp.channelbase.channel_type', { defaultValue: '渠道类型' }),
					key: 'channel_category',
					sortable: true,
				},
				{
					title: this.$t('erp.channelbase.channel_name', { defaultValue: '渠道名称' }),
					key: 'account_flag',
					sortable: true,
				},
				// {
				// 	title: '渠道标志',
				// 	key: 'accountFlag',
				// },

				{
					title: this.$t('erp.b2c.product_orgwarehouse', { defaultValue: '仓库' }),
					key: 'codes',
					render(h, { row }) {
						const data = row.codes.split(',');
						return data.map((item) => {
							return <div>{item}</div>
						})
					}
				},

				{
					title: this.$t('global.common.createdtime', { defaultValue: '创建时间' }),
					key: 'created_at',
					sortable: true,
				}, {
					title: this.$t('global.common.status', { defaultValue: '状态' }),
					width: 80,
					align: 'center',
					sortable: true,
					key: 'status',
					render(h, { row }) {
						return row.status === 1 ? <Button class="cursor-default" size='small' type='success'>{that.$t('global.common.effective', { defaultValue: '有效' })}</Button> : <Button class="cursor-default" size='small' type='error'>{that.$t('fbb.accountmanage.loss_effect', { defaultValue: '失效' })}</Button>
					}
				},
			];
		},
	},
};
</script>



